import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import ModalActionButton from '../../elements/ModalActionButton';
import { fetchDepartments } from '../../../store/actions/departmentActions';
import { updateStaff } from '../../../store/actions/staffActions';
import Loader from '../../elements/Loader';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';
import InlinePreloader from '../../elements/InlinePreloader';

const UpdateStaffDepartment = ({ staff, currentDepartment, close }) => {
    const staffSelector = useSelector(state => state.staff);
    const departmentsSelector = useSelector(state => state.departments);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchDepartments('', 0, 0))

    }, [dispatch]);

    const validateForm = () => {
        const errors = {};
        if (!selectedDepartment || !selectedDepartment._id) {
            errors['department'] = 'Department is required';
        }
        return Object.keys(errors).length === 0;
    };

    const [selectedDepartment, setSelectedDepartment] = useState(currentDepartment || {});
    const updateStaffDepartment = () => {
        if (!validateForm()) {
            return;
        }
        console.log('Selected Department:', selectedDepartment);
        const payload = {
            department: selectedDepartment._id
        };

        console.log(payload)
        dispatch(updateStaff(staff?._id, payload))
    };
    return (
        <div className="w-full">
            {departmentsSelector.loadingDepartments ? 
                <Loader />
            : 
                <>
                    {currentDepartment ? (
                        <p className="text-gray-500 text-sm">{staff?.name || 'this staff member'} is currently assigned to the department - <span className="font-semibold">{currentDepartment.name}</span>. Select a new department below to update the assignment.</p>
                    ) : (
                        <p className="text-gray-500 text-xs">No departments assigned to {staff?.name || 'this staff member'} yet. Select a department below to assign the staff.</p>
                    )}

                    <div className="mb-2 flex items-end gap-x-1 mt-4">
                        {departmentsSelector?.loadingDepartments ? 
                            <InlinePreloader />
                        : 
                        <>
                            {departmentsSelector?.departments?.departments?.length > 0 ? <AutocompleteSelect 
                                selectOptions={departmentsSelector?.departments?.departments?.filter(
                                    (option) => !currentDepartment || currentDepartment._id !== option._id
                                )}
                                inputLabel="Select New Department"
                                titleField="name"
                                displayImage={false}
                                imageField=""
                                preSelected={currentDepartment}
                                fieldId="employee-designation"
                                requiredField={true}
                                placeholderText="Select a new department"
                                hasError={false}
                                // return id of accounts of the selected option
                                returnFieldValue={(value) => {
                                    setSelectedDepartment(value);
                                }}
                            /> 
                            :
                            <div className='p-3 rounded border border-red-500 bg-red-300 bg-opacity-20'>
                                <p className='text-xs text-red-500'>No departments created yet. please create some in the administrations section first.</p>
                            </div>
                            }
                        </>
                        }
                    </div>
                </>
            }

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Department for ${staff?.name || 'Staff'}`}
                    buttonAction={updateStaffDepartment}
                    processing={staffSelector.updatingStaff}
                    disabled={departmentsSelector.loadingDepartments}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent transition duration-200 hover:bg-opacity-5 rounded-xl hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            
            </div>
        </div>
    )

}

export default UpdateStaffDepartment